import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useAuth from '../hooks/useAuth';

const menuItems = {
  passenger: [
    { label: 'Dashboard', path: '/passenger-dashboard', icon: '\uD83C\uDFE0' },
    { label: 'Search Trains', path: '/search', icon: '\uD83D\uDD0D' },
    { label: 'My Bookings', path: '/bookings', icon: '\uD83C\uDFAB' },
    { label: 'Profile', path: '/profile', icon: '\uD83D\uDC64' },
  ],
  ttr: [
    { label: 'Dashboard', path: '/ttr-dashboard', icon: '\uD83C\uDFE0' },
  ],
  admin: [
    { label: 'Dashboard', path: '/admin-dashboard', icon: '\uD83D\uDCCA' },
    { label: 'Manage Trains', path: '/manage-trains', icon: '\uD83D\uDE86' },
    { label: 'Manage Users', path: '/manage-users', icon: '\uD83D\uDC65' },
  ],
};

const Sidebar = () => {
  const { userRole } = useAuth();
  const location = useLocation();
  const sidebarOpen = useSelector(state => state.ui.sidebarOpen);

  const isActive = (path) => location.pathname === path;
  const items = menuItems[userRole] || [];

  return (
    <aside
      className={`${
        sidebarOpen ? 'w-64' : 'w-20'
      } bg-secondary text-white transition-all duration-300 min-h-screen overflow-y-auto`}
    >
      <div className="p-4">
        {items.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center space-x-3 px-4 py-3 rounded-lg mb-2 transition ${
              isActive(item.path)
                ? 'bg-primary text-white'
                : 'hover:bg-gray-700'
            }`}
          >
            <span className="text-xl">{item.icon}</span>
            {sidebarOpen && <span>{item.label}</span>}
          </Link>
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;
